import type { Cache } from 'cross-state';

export function updateIfCached<T>(cache: Cache<T, any>, update: (value: T) => T) {
    if (cache.state.get().value !== undefined) {
        cache.updateValue((value) => update(value!));
    }
}

export type UseCacheOptions<T> = NonNullable<Parameters<Cache<T, any>['useCache']>[0]>;
